import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRe = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 78 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "translate(2 22)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M53-1c.552 0 1.052.224 1.414.586C54.776-.052 55 .448 55 1h0v23H-1V1c0-.552.224-1.052.586-1.414A1.994 1.994 0 011-1h0z",
					stroke: "#0D0E10",
					strokeWidth: 2,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55 24v8H35.93a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0129 38a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.043-3.85h0l-4.177-.157a6.981 6.981 0 01-1.974 3.915A6.978 6.978 0 0111 38a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.046-3.866h0L.968 32a1.994 1.994 0 01-1.382-.586A1.994 1.994 0 01-1 30h0v-6h56zM67.53 5a2.996 2.996 0 012.863 2.105h0l4.47 14.305a3 3 0 01.137.895h0V30c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0173 32h0-2.07a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0164 38a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.053-3.913h0L55 31.894V20h4V7c0-.552.224-1.052.586-1.414A1.994 1.994 0 0161 5h0z",
					stroke: "#0D0E10",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#0D0E10",
					d: "M63 6h2v13h-2zM60 19h14v2H60z"
				}),
				/* @__PURE__ */ _jsx("circle", {
					fill: "#0D0E10",
					cx: 11,
					cy: 32,
					r: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					fill: "#0D0E10",
					cx: 29,
					cy: 32,
					r: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					fill: "#0D0E10",
					cx: 64,
					cy: 32,
					r: 2
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			d: "M13.486 34.79l-.173.086c-.785.44-1.508.88-2.27 1.312a.354.354 0 00-.189.244c-.133.55-.29 1.092-.432 1.634-.055.212-.118.424-.173.636a.59.59 0 01-1.103.155.581.581 0 01-.02-.485l.306-1.147v-.149l-.785.464-.998.573a.573.573 0 01-.785-.188.581.581 0 01.235-.786l1.713-.99.157-.094-.888-.244-.565-.149a.581.581 0 01.078-1.131.864.864 0 01.283 0c.786.204 1.532.4 2.286.62a.51.51 0 00.456-.062l2.184-1.265.094-.055-.738-.425-1.792-1.029a.314.314 0 00-.188 0l-2.357.621a.566.566 0 01-.723-.424.573.573 0 01.424-.692l1.226-.33h.11l-1.14-.66c-.25-.14-.494-.274-.738-.424a.583.583 0 11.59-1.005l1.72.99.15.086c-.056-.22-.11-.416-.158-.613-.047-.196-.165-.573-.228-.864a.55.55 0 01.425-.676.558.558 0 01.69.385c.229.786.449 1.619.653 2.436a.314.314 0 00.18.235l2.271 1.312.15.087a1.163 1.163 0 000-.157v-2.624a.377.377 0 00-.134-.314c-.354-.323-.684-.668-1.022-1.006l-.785-.786a.581.581 0 01.267-.958.605.605 0 01.597.165c.299.314.605.613.911.92 0 0 .047.07.079.101h.04v-2.082a.581.581 0 01.604-.628.558.558 0 01.558.503.856.856 0 010 .141v2.011h.04l.518-.534.416-.416a.605.605 0 01.84 0 .581.581 0 010 .832l-1.76 1.76a.18.18 0 00-.054.11V32.7a.196.196 0 000 .055l1.092-.628 1.233-.707a.37.37 0 00.228-.299c.041-.266.104-.53.189-.785.149-.542.29-1.092.44-1.634a.581.581 0 01.903-.315c.197.14.285.388.22.62l-.353 1.336a.613.613 0 000 .11l.282-.165 1.572-.919a.64.64 0 11.73 1.053l-1.437.833-.378.22 1.1.298.29.079a.581.581 0 01.088 1.058.566.566 0 01-.448.034c-.786-.197-1.572-.393-2.31-.613a.48.48 0 00-.4.055c-.786.44-1.501.864-2.248 1.296l-.125.079.125.078 2.192 1.265c.1.074.23.092.346.047.3-.099.603-.183.911-.251.472-.126.943-.26 1.422-.377a.581.581 0 11.299 1.115l-1.383.378.134.086 1.744 1.006a.581.581 0 01-.126 1.068.628.628 0 01-.487-.07l-1.666-.951-.133-.071.243.927c.04.134.079.267.11.4a.581.581 0 11-1.123.3c-.212-.786-.424-1.572-.644-2.397a.165.165 0 00-.047-.078l-2.483-1.43v2.812c0 .11.07.15.134.204l1.249 1.25.424.424a.573.573 0 010 .848.581.581 0 01-.84 0l-.818-.872-.125-.118v2.106a.581.581 0 11-1.163 0v-2.168a1.123 1.123 0 00-.094.086l-.975.958a.581.581 0 01-.974-.227.542.542 0 01.134-.582c.573-.581 1.139-1.162 1.728-1.72a.495.495 0 00.165-.409V34.79z",
			fill: "#1D1D1B",
			fillRule: "nonzero"
		})]
	})
});
export default SvgRe;
